import { render } from "./chargemachinepos.vue?vue&type=template&id=fa4b5cba"
import script from "./chargemachinepos.vue?vue&type=script&lang=js"
export * from "./chargemachinepos.vue?vue&type=script&lang=js"

import "./chargemachinepos.vue?vue&type=style&index=0&id=fa4b5cba&lang=css"
script.render = render

export default script